import React, { memo } from "react";

import { Row as AntdRow } from "antd";
import { RowProps } from "antd/lib/row";

const Row = (props: RowProps) => {
  return <AntdRow {...props} />;
};

export default memo(Row);
